const unitPriceElement = document.getElementById("unit-price-patch");
const amountInputElement = document.querySelector("#popover-variant-picker-template--17933044220169__main-1657033064548-1 > x-listbox > input[type=hidden]");

let transcyMoneySpans;
console.log('bbababababa')

amountInputElement.addEventListener("change", ()=> {
  
  // get all spans inside price
  transcyMoneySpans = unitPriceElement.querySelectorAll(".transcy-money")
  console.log('rararara')
  
  // remove the previous span
  transcyMoneySpans[0].remove()
  unitPriceElement.innerHTML += ")"

})